import { Spin } from 'antd';
import { cn } from '../../../utils/string/cn.utils';

const ButtonSecondaryMedium = ({
  type = 'button',
  id,
  title,
  disabled,
  style,
  preIcon,
  posIcon,
  onClick,
  loading = false,
  ...props
}) => {
  return (
    <button
      type={type}
      id={id}
      className={cn(
        'inline-flex justify-center items-center bg-fills-white border-[1px] border-solid border-outline-brand-primary text-primary-primary hover:bg-primary-primaryFill disabled:bg-fills-disable disabled:border-outline-default-disable disabled:text-black-low',
        'h-[32px] py-[7px] px-[12px] gap-[6px] label-medium font-semibold rounded-[6px]',
        props.className
      )}
      disabled={disabled}
      style={{
        ...style,
        ...{
          paddingRight: `${preIcon ? '8px' : undefined}`,
          paddingLeft: `${posIcon ? '8px' : undefined}`,
        },
      }}
      onClick={onClick}
    >
      {posIcon && (
        <div className="flex flex-row justify-center items-center w-[18px] h-[18px] text-primary-primary disabled:text-black-low">
          {posIcon}
        </div>
      )}
      <span className="truncate text-primary-primary disabled:text-black-low">
        {title}
      </span>
      <Spin spinning={loading} size={20} />
      {preIcon && (
        <div className="flex flex-row justify-center items-center w-[18px] h-[18px] text-primary-primary disabled:text-black-low">
          {preIcon}
        </div>
      )}
    </button>
  );
};

export default ButtonSecondaryMedium;
